import React from 'react';
import styled from 'styled-components';
import { injectGlobal, css } from 'emotion';
import Row from '../Row';
import { Transition, animated, interpolate } from 'react-spring/renderprops';
import OtpInput from 'react-otp-input';
import axios from 'axios';
import { connect } from 'react-redux';
import { urls as urls } from '../../api/urls';
import { loginUser, updateUser, fetchProfile, flushUserState } from '../../actions/userActions';
import { fetchTrips } from '../../actions/tripActions';
import moment from 'moment';

// import { animated, interpolate } from 'react-spring/renderprops'

/* global tw */
const Wrapper = styled.div`
    ${tw`w-screen bg-white fixed z-999 pin-t overflow-hidden`};
    height: 85vh;
    border-radius: 0 0 32px 32px;
    z-index: 100;

`
const CarGraphic = styled.img`
    ${tw`lg:flex-col row-reverse`};
    height: 30vh;
`
const FormWrapperColumn = styled.div`
    ${tw`w-full lg:w-2/3 lg:text-right flex items-center justify-end relative`};
    height: 10rem;
    // background: green;
`
const HeaderLogo = styled.img`
    ${tw`h-8`}
    height: 5vh;

`
const InputLabel = styled.p`
    ${tw`text-xl font-medium text-blackGrey opacity-50 mb-4`};
`

const LoginPhoneInput = styled.input`
    ${tw`lg:w-4/5 w-full text-blackGrey font-black font-brand py-2 pr-2 -mr-2 border-none border-0 appearance-none shadow-none bg-grey-light rounded-lg outline-none opacity-70`};
    font-size: 4rem;
    letter-spacing: -2.32px;
    text-align: right;
    
`

const PagesLinksList = styled.ul`
    ${tw`list-reset`};
    li{
        ${tw`my-1 inline-block mx-2 `}
        a{
            ${tw`no-underline font-medium text-blackGrey opacity-50 hover:opacity-70 cursor-pointer py-1 px-2`}
        }
    }
`
const FooterLinks = styled(PagesLinksList)`
    ${tw`list-reset`};
    li{
        ${tw`my-1 inline-block mx-2 `}
        a{
            ${tw`no-underline text-sm font-medium text-blackGrey opacity-50 hover:opacity-70 cursor-pointer py-1 px-2`}
        }
    }
`

const UserName = styled.h3`
    ${tw`font-black font-brand m-0`};
    opacity: 0.77;
    font-size: 3rem;
    color: #242424;
    letter-spacing: -2.32px;
    line-height: 1;
`
const UserPhone = styled.p`
    ${tw`text-sm opacity-50`}
`
const RewardPoints = styled.h3`
    ${tw`font-light font-brand m-0`};
    opacity: 0.77;
    font-size: 3rem;
    color: #242424;
    letter-spacing: -${2.32 / 2}px;
    line-height: 1;
`
const RewardPointsLabel = styled.p`
    ${tw`text-sm opacity-50`}
`

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPhoneEntered: false,
            isNameEntered: false,
            isEmailEntered: false,
            isLoggedIn: false,
            phoneNumber: null,
            email: null,
            name: null,
            step: 1,
            countryCode: 91,
            otp: null,
            // showLoginButton: false,
        }
        this.handleBack = this.handleBack.bind(this);
        this.handleOtp = this.handleOtp.bind(this);
        this.handleStep = this.handleStep.bind(this);
        this.handlePhoneInput = this.handlePhoneInput.bind(this);
        this.handleEmailInput = this.handleEmailInput.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);

    }

    handleStep() {
        this.setState({
            // isNameEntered: true,
            step: this.state.step + 1
        });
    }


    handleBack() {
        this.setState({
            step: this.state.step - 1
        })
    }

    handleOtp(otp) {
        if (otp.length === 4) {
            this.authenticateOtp(otp);
        }
    }

    handlePhoneInput(event) {
        this.setState({ phoneNumber: event.target.value });
    }

    handleEmailInput(event) {
        this.setState({ email: event.target.value });
    }

    handleNameInput(event) {
        this.setState({ name: event.target.value });
    }

    sendOtp = () => {
        ;
        let self = this;
        let url = urls.sendOtpUrl;
        // this.otpInput.focus();
        let otpInput = {
            "user": {
                "name": this.state.name,
                "emailId": this.state.email,
                "mobileNo": Number(this.state.phoneNumber),
                "countryCode": Number(this.state.countryCode),
                "fcmId": this.props.fcmToken ? this.props.fcmToken : ' '
            },
            "loginType": "CUSTOMER"
        }
        self.props.dispatch(updateUser({ name: self.state.name, phone: self.state.phoneNumber, email: self.state.email }));
        self.setState({ step: self.state.step + 1 });
        axios.post(url, otpInput)
            .then(function (response) {
                
                console.log(response);
            })
            .catch(error => { ; console.log(error) })
    }


    authenticateOtp = (otp) => {
        console.log(otp);
        this.setState({ error: '' });
        let self = this;
        
        let url = urls.authOtpUrl;
        let authinput = {
            "otp": otp,
            "loginType": "CUSTOMER"
        }

        axios.post(url, authinput)
            .then(function (response) {
                
                // let self = this;
                if (response.data.statusCD === 200) {
                    self.setState({ isUserLoggedIn: true });
                    let user = response.data.responseData;
                    console.log(response.data.responseData);
                    // storeKey('user', { name: user.name, phone: user.mobileNo, email: user.emailId, id: user.id });
                    if (!self.props.isUserLoggedIn) {
                        self.props.dispatch(updateUser({ name: self.state.name, phone: self.state.phoneNumber, email: self.state.email }));
                        self.props.dispatch(loginUser());
                    }
                    // eslint-disable-next-line
                    analytics.identify("User Authenticated", { name: self.state.name, email: self.state.email, phone: self.state.phoneNumber, id: user.id });
                    self.props.dispatch(fetchTrips(self.props.user.phoneNumber));
                    self.props.dispatch(fetchProfile(self.props.user.phoneNumber));

                }
                else if (response.data.statusCD === 401) {
                    // alert("Invalid OTP");
                    self.setState({ error: 'Invalid OTP' });

                }
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    render() {
        const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        return (
            <Wrapper>
                <div className={css`height: 100%; ${tw`relative flex flex-wrap items-center`}`}>

                    <Row justifyBetween className={css`height: 5%;`}>
                        <HeaderLogo src={require('../../assets/img/logo-with-text.svg')} />
                        <p className={css`${tw`cursor-pointer`}`} onClick={this.props.onClosePress}>Close</p>
                    </Row>
                    <Row justifyBetween className={css`${tw`items-center relative w-full max-w-full  overflow-hidden`}; height: 80%;`}>

                        <Transition
                            native
                            items={!this.props.isUserLoggedIn}
                            from={{ x: 1000, o: 0 }}
                            enter={{ x: 0, o: 1 }}
                            leave={{ x: -1000, o: 0 }}
                            config={{ tension: 100, friction: 20 }}
                            initial={null}
                        >

                            {items =>

                                items
                                    ? ({ x, o }) =>

                                        <animated.div
                                            style={{
                                                transform: x.interpolate(x => `translate3d(${x}px, 0,0)`),
                                                opacity: o.interpolate(o => o),
                                            }}
                                            // style={props}
                                            className={css`${tw`absolute flex items-center h-full w-full pin-l pin-t`}`}>
                                            <Row justifyBetween>
                                                <div className={css`${tw`w-full lg:w-1/3 items-center hidden lg:flex`}`}>
                                                    <CarGraphic src={require('../SvgComponents/isometric-car-left.svg')} alt="Zyppys Car Rental" />
                                                </div>
                                                <FormWrapperColumn>

                                                    {this.state.step === 1 &&
                                                        <Transition
                                                            native
                                                            items={!this.state.isNameEntered}
                                                            from={{ o: 0, t: 30 }}
                                                            enter={{ o: 1, t: 0 }}
                                                            leave={{ o: 0, t: -40 }}
                                                            config={{ tension: 100, friction: 20 }}>
                                                            {items =>
                                                                ({ o, t }) =>
                                                                    <animated.div className={css`${tw`pin-t pin-l lg:pin-r absolute text-right`}; will-change: transform, opacity;`}
                                                                        style={{
                                                                            opacity: o,
                                                                            transform: t.interpolate(t => `translate3d(0, ${t}px, 0)`)
                                                                        }}>
                                                                        <InputLabel>What do we call you?</InputLabel>
                                                                        <LoginPhoneInput
                                                                            onChange={this.handleNameInput}
                                                                            type='name'
                                                                            maxLength='15'
                                                                            minLength='2'
                                                                            placeholder="Your Name"
                                                                            value={this.state.name}
                                                                        />

                                                                        <Transition
                                                                            native
                                                                            from={{ y: 50, o: 0 }}
                                                                            enter={{ y: 0, o: 1 }}
                                                                            leave={{ y: 50, o: 0 }}
                                                                            items={this.state.name !== null && this.state.name.length >= 3}>
                                                                            {
                                                                                items => items &&
                                                                                    (props =>
                                                                                        <animated.div onClick={this.handleStep}
                                                                                            style={{
                                                                                                transform: props.y.interpolate(y => `translate3d(0, ${y}px, 0)`),
                                                                                                opacity: props.o

                                                                                            }}
                                                                                            className={css`${tw`text-xl border-none appearance-none py-2 mt-8 cursor-pointer bg-transparent text-brandPurple font-brand font-medium`}`}>
                                                                                            <div className={css`${tw`inline-flex items-center`}`}>
                                                                                                Next <img src={require('../SvgComponents/proceedCircle.svg')} className={css`${tw`inline-flex ml-4 h-10`}`} />
                                                                                            </div>
                                                                                        </animated.div>)
                                                                            }

                                                                        </Transition>

                                                                    </animated.div>
                                                            }
                                                        </Transition>
                                                    }

                                                    {this.state.step === 2 &&
                                                        <Transition
                                                            native
                                                            items={!this.state.isNameEntered}
                                                            from={{ o: 0, t: 30 }}
                                                            enter={{ o: 1, t: 0 }}
                                                            leave={{ o: 0, t: -40 }}
                                                            config={{ tension: 100, friction: 20 }}>
                                                            {items =>
                                                                ({ o, t }) =>
                                                                    <animated.div className={css`${tw`pin-t pin-l lg:pin-r absolute text-right`}; will-change: transform, opacity;`}
                                                                        style={{
                                                                            opacity: o,
                                                                            transform: t.interpolate(t => `translate3d(0, ${t}px, 0)`)
                                                                        }}>
                                                                        <InputLabel>Where do we reach you? </InputLabel>
                                                                        <LoginPhoneInput
                                                                            onChange={this.handleEmailInput}
                                                                            type='email'
                                                                            placeholder="Your Email"
                                                                            value={this.state.email}
                                                                        />

                                                                        <Transition
                                                                            native
                                                                            from={{ y: 50, o: 0 }}
                                                                            enter={{ y: 0, o: 1 }}
                                                                            leave={{ y: 50, o: 0 }}

                                                                            items={reg.test(this.state.email)}>
                                                                            {
                                                                                items => items &&
                                                                                    (props =>
                                                                                        <animated.div onClick={this.handleStep}
                                                                                            style={{
                                                                                                transform: props.y.interpolate(y => `translate3d(0, ${y}px, 0)`),
                                                                                                opacity: props.o

                                                                                            }}
                                                                                            className={css`${tw`text-xl border-none appearance-none py-2 mt-8 cursor-pointer bg-transparent text-brandPurple font-brand font-medium`}`}>
                                                                                            <div className={css`${tw`inline-flex items-center`}`}>
                                                                                                Next <img src={require('../SvgComponents/proceedCircle.svg')} className={css`${tw`inline-flex ml-4 h-10`}`} />
                                                                                            </div>
                                                                                        </animated.div>)
                                                                            }

                                                                        </Transition>

                                                                    </animated.div>
                                                            }
                                                        </Transition>
                                                    }

                                                    {this.state.step === 3 &&
                                                        <Transition
                                                            native
                                                            items={!this.state.isPhoneEntered}
                                                            from={{ o: 0, t: 30 }}
                                                            enter={{ o: 1, t: 0 }}
                                                            leave={{ o: 0, t: -40 }}
                                                            config={{ tension: 100, friction: 20 }}>
                                                            {items =>
                                                                ({ o, t }) =>
                                                                    <animated.div className={css`${tw`pin-t pin-l lg:pin-r absolute text-right`}; will-change: transform, opacity;`}
                                                                        style={{
                                                                            opacity: o,
                                                                            transform: t.interpolate(t => `translate3d(0, ${t}px, 0)`)
                                                                        }}>
                                                                        <InputLabel>Login / Signup</InputLabel>
                                                                        <LoginPhoneInput
                                                                            onChange={this.handlePhoneInput}
                                                                            type='number'
                                                                            maxLength='10'
                                                                            minLength='10'
                                                                            placeholder="Your Phone #"
                                                                            value={this.state.phoneNumber}
                                                                        />

                                                                        <Transition
                                                                            native
                                                                            from={{ y: 50, o: 0 }}
                                                                            enter={{ y: 0, o: 1 }}
                                                                            leave={{ y: 50, o: 0 }}
                                                                            items={this.state.phoneNumber !== null && this.state.phoneNumber.length === 10}>
                                                                            {
                                                                                items => items &&
                                                                                    (props =>
                                                                                        <animated.div onClick={this.sendOtp}
                                                                                            style={{
                                                                                                transform: props.y.interpolate(y => `translate3d(0, ${y}px, 0)`),
                                                                                                opacity: props.o

                                                                                            }}
                                                                                            className={css`${tw`text-xl border-none appearance-none py-2 mt-8 cursor-pointer bg-transparent text-brandPurple font-brand font-medium`}`}>
                                                                                            <div className={css`${tw`inline-flex items-center`}`}>
                                                                                                Send OTP <img src={require('../SvgComponents/proceedCircle.svg')} className={css`${tw`inline-flex ml-4 h-10`}`} />
                                                                                            </div>
                                                                                        </animated.div>)
                                                                            }

                                                                        </Transition>

                                                                    </animated.div>
                                                            }

                                                        </Transition>
                                                    }

                                                    {this.state.step === 4 &&
                                                        <Transition
                                                            native
                                                            items={!this.state.isPhoneEntered}
                                                            from={{ o: 0, t: 30 }}
                                                            enter={{ o: 1, t: 0 }}
                                                            leave={{ o: 0, t: -40 }}
                                                            config={{ tension: 100, friction: 20 }}>
                                                            {items =>
                                                                ({ o, t }) => <animated.div className={css`${tw`pin-t pin-l lg:pin-r absolute`}; will-change: transform, opacity;`}
                                                                    style={{
                                                                        opacity: o,
                                                                        transform: t.interpolate(t => `translate3d(0, ${t}px, 0)`)
                                                                    }}>
                                                                    <InputLabel style={{ width: '100%' }}>Enter OTP</InputLabel>

                                                                    <OtpInput
                                                                        onChange={otp => this.handleOtp(otp)}
                                                                        numInputs={4}
                                                                        shouldAutoFocus
                                                                        isInputNum
                                                                        containerStyle={{
                                                                            // width: '10rem',
                                                                            justifyContent: 'flex-end',
                                                                        }}
                                                                        inputStyle={{
                                                                            color: `#545454`,
                                                                            fontWeight: `black`,
                                                                            fontFamily: `Chromatica`,
                                                                            padding: `0.1rem`,
                                                                            border: `none`,
                                                                            WebkitAppearance: 'none',
                                                                            backgroundColor: `rgba(245,245,255,1)`,
                                                                            borderRadius: `8px`,
                                                                            fontSize: `4rem`,
                                                                            width: `80%`,
                                                                            outline: 0,
                                                                        }}
                                                                    />
                                                                    <div onClick={this.handleBack} className={css`${tw`text-sm border-none appearance-none py-2 mt-8 cursor-pointer bg-transparent text-brandPurple font-brand inline-flex items-center opacity-60 hover:opacity-100 mr-2`}`}>
                                                                        Resend OTP / Change Number
                                                                </div>
                                                                    {/* <LoginPhoneInput type='number' maxLength='10' minLength='10' placeholder="OTP" /> */}
                                                                </animated.div>

                                                            }

                                                        </Transition>
                                                    }


                                                </FormWrapperColumn>
                                            </Row>

                                        </animated.div>

                                    : ({ x, o }) =>
                                        <animated.div
                                            style={{
                                                transform: x.interpolate(x => `translate3d(${x}px, 0, 0)`),
                                                opacity: o.interpolate(o => o),
                                            }}
                                            className={css`${tw`absolute flex flex-wrap items-center h-full w-full pin-l pin-t`}`}>

                                            <Row className={css`${tw`-mb-8`}`}>
                                                <div className={css`${tw`w-auto pr-8 py-4`}`}>

                                                    <UserName>{this.props.user.name}</UserName>
                                                    <UserPhone>+91 {this.props.user.phone}</UserPhone>
                                                </div>
                                                <div className={css`${tw`w-auto pl-8 py-4`}; border-left: 1px solid rgba(10,10,10,0.1)`}>

                                                    <RewardPoints>{this.props.user.profile.totalPoints}</RewardPoints>
                                                    <RewardPointsLabel>Reward Points</RewardPointsLabel>
                                                </div>
                                            </Row>
                                            <Row className={css`${tw``}`}>
                                                <div className={css`${tw`w-full`}`}>
                                                    <p className={css`${tw`text-2xl font-black tracking-tight text-blackGrey opacity-50`}`}>Your Bookings</p>
                                                </div>
                                            </Row>
                                            <div className={css`${tw`relative overflow-hidden w-full -mt-8`} height: 16rem;`}>
                                                {this.props.trips.length > 0 &&
                                                    <div className={css`${tw`flex flex-no-wrap overflow-y-scroll scrolling-touch w-full pl-4 lg:pl-16`}; padding-bottom: 10rem; -webkit-overflow-scrolling: touch; cursor: grab; cursor: -moz-grab; cursor: -webkit-grab;`}>
                                                        {
                                                            this.props.trips.map((trip, i) => {
                                                                return (<BookingCard trip={trip} key={i} />);
                                                            })
                                                        }
                                                    </div>
                                                }
                                            </div>

                                        </animated.div>

                            }

                        </Transition>

                    </Row>
                    <Row justifyBetween className={css`${tw`relative`}; height: 10%;`}>
                        <PagesLinksList>
                            <li>
                                <a>Top Destinations</a>
                            </li>
                            <li>
                                <a>Partnerships</a>
                            </li>
                            <li>
                                <a>About</a>
                            </li>
                        </PagesLinksList>
                        <FooterLinks>
                            <li>
                                <a href="tel:+918688901902">+91 8688 901 902</a>
                            </li>
                            <li>
                                <a>hello@zyppys.com</a>
                            </li>
                        </FooterLinks>
                    </Row>
                </div>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    isUserLoggedIn: state.user.isLoggedIn,
    user: state.user,
    trips: state.trip.all,
})

export default connect(mapStateToProps)(Menu);

injectGlobal`
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
    }
`


const BookingVendorLogo = styled.img`
    ${tw`block h-6 mb-2`};
`
const Destinations = styled.p`
    span{
        ${tw`block text-blackGrey font-brand font-light tracking-halfpx`};
        opacity: 0.77;
        font-size: 0.8rem;
        
    }
`

const TripDates = styled.p`
    ${tw`text-blackGrey font-brand font-light tracking-halfpx mt-2`};
    opacity: 0.45;
    font-family: Chromatica-Medium;
    font-size: 1rem;
    letter-spacing: 0;
`
const CarImage = styled.img`
    ${tw`h-12 `};
`

const BookingVendorLogoAha = styled.img`
    ${tw`h-6 mt-1 mb-4`};
`
const BookingCard = (props) => (
    <div className={css`${tw`bg-grey-light py-6 px-12 mr-12 rounded-lg`}; min-width: 14.5rem; height: 15rem;`}>
        <CarImage src={props.trip.subCategoryUrl} />
        {
            props.trip.accountId === 4 ?

                <BookingVendorLogoAha src={props.trip.imageUrl} />
                :
                <BookingVendorLogo src={props.trip.imageUrl} />

        }
        <Destinations>
        {props.trip.hasOwnProperty("destinationLocality") && props.trip.destinationLocality !== '' && <span>
            <span>
                {props.trip.destinationLocality.split(',')[0]}
            </span>
            <span> - </span>
            </span>}
            <span>
                {props.trip.pickupCity}
            </span>
        </Destinations>
        <TripDates>{moment(props.trip.rideStartDate, 'DD-MM-YYYY').format('DD MMM')}</TripDates>
    </div>
);


